import { useListItemDataProvider } from "@circle-react-shared/uikit/SortableList";

import { LinkItemContent } from "./LinkItemContent";

export const LinkItemDragOverlay = () => {
  const { item: link }: any = useListItemDataProvider();

  return <LinkItemContent link={link} />;
};
